import { render } from "./OrderCounter.vue?vue&type=template&id=4c96e588"
import script from "./OrderCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCounter.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/components/OrderCounter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c96e588"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c96e588', __exports__)) {
    console.log('reload')
    api.reload('4c96e588', __exports__)
  }
  
  module.hot.accept("./OrderCounter.vue?vue&type=template&id=4c96e588", () => {
    console.log('re-render')
    api.rerender('4c96e588', render)
  })

}


export default __exports__